import styled from "styled-components";

export const Container = styled.div`
  background-color: #366796;
  display: flex;
  justify-content: center;
  width: 100vw;
`;
export const SizeContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 100vh;
  max-width: 500px;
  width: 100%;
`;

export const ContainerInput = styled.div`
  align-items: center;
  background-color: #fa821f;
  border-radius: 0 0 12px 12px;
  display: flex;
  height: 130px;
  justify-content: center;
  margin: -15px auto 10px;
  padding: 3px;
  padding-top: 25px;
  width: 95%;
`;
